export default __webpack_public_path__ + "static/media/calendar.fd5638e7.svg";